import React from 'react'
import './styles.scss'
import { Question } from 'components/Question'
import { Answer } from 'components/Answer'

interface Props {
  data: QandAT
}

export const QandA = ({ data }: Props) => {
  const { name, info, question, answer } = data
  return (
    <div className='QandA'>
      <Question name={name} info={info} text={question} />
      <Answer text={answer} />
    </div>
  )
}
